import React from 'react';

import { useLayoutContext } from '@contexts/LayoutContext';

import { NavMenu } from '@components/_LayoutComponents/Header/NwHeaderUI';

import { getNavClassName, getNavMenuMode } from './NwNavUtils';

const NwNavBarArtMobile = ({ current, drawer, handleChangeOpenKeys, handleClick, isLoaded, openKeys }) => {
    const layoutContext = useLayoutContext();
    const { breakpoints } = layoutContext;

    const navItems = [
        // dashboard temporaneamente fuori dal menu: l'area parte dal website
        //{ key: '/art', label: 'Dashboard', disabled: !isLoaded },
        { key: '/art/website', label: 'Website Structure', disabled: !isLoaded },
        { key: '/art/news', label: 'News', disabled: !isLoaded },
        { key: '/art/articles', label: 'Articles', disabled: !isLoaded },
        { key: '/art/galleries', label: 'Galleries', disabled: !isLoaded },
        { key: '/art/uploads', label: 'Uploads', disabled: !isLoaded },
        { key: '/art/model-contents', label: 'Model Contents', disabled: !isLoaded },
    ];

    const keysWithSubmenus = navItems.filter((item) => item.children).map((item) => item.key);

    return (
        <NavMenu
            className={getNavClassName(breakpoints, navItems.length)}
            inlineIndent={10}
            items={navItems}
            mode={getNavMenuMode(drawer, breakpoints)}
            onClick={handleClick}
            onOpenChange={(k) => handleChangeOpenKeys(k, keysWithSubmenus)}
            openKeys={openKeys}
            selectedKeys={[current]}
        />
    );
};

export default NwNavBarArtMobile;
